/// <amd-module name="Artifacts/Pypi/commands/UpstreamOverride" />

import { PypiActions } from "Artifacts/Pypi/redux";
import { getUpstreamOverrideCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createUpstreamOverrideCommand = getUpstreamOverrideCommandCreator(
  PypiActions.setUpstreamOverride,
);
